import React from "react";
import classnames from "classnames";

import "../../assets/styles/Modal.scss";

export interface ModalProps {
  open: boolean;
  children: React.ReactNode;
  overlay?: boolean;
  bottom?: boolean;
  toggle(): void;
}

export interface ModalState {}

export const Modal = (props: ModalProps) => {
  const { open, children, overlay, bottom } = props;
  const toggle = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    if (e.target === e.currentTarget) {
      props.toggle();
    }
  };
  return open ? (
    <div className={classnames("modal", { overlay, bottom })} onClick={toggle}>
      <div className="modal-content">
        <div className="modal-header">
          <div className="close mark invalid" onClick={toggle}></div>
        </div>
        <div className="modal-body">{children}</div>
      </div>
    </div>
  ) : null;
};

export default Modal;
